<sl-branding-gate [ready]="brandingState.ready()" [failed]="brandingState.failed()" (retry)="retryBranding()" [loadingLabel]="'Cargando…' | slT" [errorLabel]="'No se pudo cargar la configuración de esta empresa.' | slT" [retryLabel]="'Reintentar' | slT">
<header class="interface-header">
<div class="interface-brand"><img [src]="brandLogoUrl()" [alt]="brandName()"/></div>
<div class="interface-language"><sl-language-selector /></div>
</header>
<!-- Bottom Navigation (only authenticated, non-public routes) -->
@if (shouldShowBottomNav()) {
<sl-bottom-nav [items]="bottomNavItems" [activeId]="activeBottomNavId" [highlightedId]="activeBottomNavId" (selected)="navigateBottom($event)"></sl-bottom-nav>
}

<!-- Main Content -->
<main [style.--sl-engagement-top-offset.px]="installBannerVisible() ? bannerOffset() : 0" [style.padding-top.px]="installBannerVisible() ? bannerOffset() : null" [class.with-nav]="shouldShowBottomNav()" [ngStyle]="getBrandStyles()">
  <router-outlet></router-outlet>
</main>

<!-- PWA Install Banner -->
@if (installBannerVisible()) {
<sl-install-prompt [compact]="true" #installBanner [manual]="isIosPwa()" (install)="installPwa()" (dismiss)="dismissBanner()"></sl-install-prompt>
}

<sl-toast-container></sl-toast-container>

@if (loginRequest.pending(); as request) {
  <sl-dialog [open]="true" [title]="loginPopup.accountLink() ? ('¿Eres tú?' | slT) : ('Iniciar sesión' | slT)" variant="auth" size="md" (closeDialog)="loginRequest.dismiss()">
    <app-login #loginPopup presentation="popup" [context]="request" (authenticated)="loginRequest.complete()" (exitPopup)="loginRequest.complete()" />
  </sl-dialog>
}

<app-phone-verification />

@if(appUpdates.available()){
  <aside class="app-update-notice" [attr.aria-label]="'Actualización disponible' | slT" aria-live="polite">
    <sl-alert variant="info">{{ 'Hay una versión nueva.' | slT }} <button sl-button variant="primary" type="button" [disabled]="appUpdates.applying()" (click)="appUpdates.apply()">{{ appUpdates.applying() ? ('Actualizando…' | slT) : ('Actualizar ahora' | slT) }}</button>
      @if(appUpdates.error()){<p role="alert">{{ (appUpdates.error() | slT) }}</p>}
    </sl-alert>
  </aside>
}

</sl-branding-gate>
